import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BillingManagementService } from 'src/service/billing-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { FocusInputType, InteractionType, LocalService, NumericConfig, PrepaidDetailReason, Status, TriggeredEvent } from 'src/service/local.service';
import { ProfileManagementService } from 'src/service/profile-management.service';

@Component({
  selector: 'app-refund-config',
  templateUrl: './refund-config.component.html',
  styleUrls: ['./refund-config.component.scss']
})
export class RefundConfigComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["refund"];
  @Input() userOrBusinessId = ''; @Input() interactionType: InteractionType = InteractionType.None; @Input() countryCode = '';
  strUpi: string = ''; notes: string = ''; dblAmount: number = null; paymentId: string = '';
  elementIds: any = {
    txt_refund_upi: 'txt_refund_upi',
    txt_refund_notes: 'txt_refund_notes',
    txt_refund_amount: 'txt_refund_amount',
    txt_refund_save: 'txt_refund_save',
    txt_refund_payment_id: "txt_refund_payment_id"
  };
  numericConfig: NumericConfig = { isDecimalAllowed: true } as NumericConfig;

  constructor(public localService: LocalService, private languageManagementService: LanguageManagementService, private profileManagementService: ProfileManagementService, private billingManagementService: BillingManagementService, private activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onLoad();
  }

  onLoad() {
    this.profileManagementService.getUpi(this.localService.getLoginAsCountryCode() , this.userOrBusinessId, this.interactionType).subscribe(result => {
      if (result.status == Status.Success) {
        this.strUpi = result.id;
        this.localService.onFocusNextInput(this.elementIds.txt_refund_amount, FocusInputType.TextBox);
      } else {
        this.localService.onFocusNextInput(this.elementIds.txt_refund_upi, FocusInputType.TextBox);
      }
    });
  }

  onPopupClose() {
    this.activeModal.close({ event: TriggeredEvent.Close });
  }

  onPopupSave() {
    if (this.doCheck()) {
      this.billingManagementService.paidByCompany(this.userOrBusinessId, this.interactionType, this.dblAmount, PrepaidDetailReason.Refund, this.strUpi, this.notes, this.countryCode, this.paymentId).subscribe(result => {
        this.localService.showInformationByStatus(result.status);
        if (result.status == Status.Success) {
          this.activeModal.close({ event: TriggeredEvent.Ok });
        }
      });
    }
  }

  doCheck(): boolean {
    let rtn = false;
    if (!this.strUpi) {
      this.localService.onFocusNextInput(this.elementIds.txt_refund_upi, FocusInputType.TextBox);
    } else if (!this.dblAmount || this.dblAmount <= 0) {
      this.localService.onFocusNextInput(this.elementIds.txt_refund_amount, FocusInputType.TextBox);
    } else if (!this.paymentId) {
      this.localService.onFocusNextInput(this.elementIds.txt_refund_payment_id, FocusInputType.TextBox);
    } else {
      rtn = true;
    }
    if (!rtn) {
      this.localService.showInformationByStatus(Status.DataRequired);
    }
    return rtn;
  }

}
